import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../services.css'
import ios from '../../../images/services/apple.svg';
import android from '../../../images/services/android.svg';
import webApp from '../../../images/services/code-tag.svg';
import ml from '../../../images/services/algorithm.svg';
import cloud from '../../../images/services/brainstorm.svg';
import blockchain from '../../../images/services/cube.svg';
import ai from '../../../images/services/knowledge.svg';
import devops from '../../../images/services/share.svg';
import rpa from '../../../images/services/robotic-arm.svg';
import iot from '../../../images/services/virtual.svg';

const ServicesCards = () => {
    const services = [
        {
            icon: ios,
            alt: 'apple',
            title: 'IOS Mobile App Development',
            link: '/services/ios_app',
        },
        {
            icon: android,
            alt: 'android',
            title: 'Android Mobile App Development',
            link: '/services/android_app',
        },
        {
            icon: webApp,
            alt: 'web development',
            title: 'Web Application Development',
            link: '/services/web_app',
        },
        {
            icon: cloud,
            alt: 'cloud strategy',
            title: 'Cloud Strategy & Development',
            link: '/services/cloud_strategy',
        },
        {
            icon: blockchain,
            alt: 'blockchain',
            title: 'Blockchain Applications',
            link: '/services/blockchain_app',
        },
        {
            icon: rpa,
            alt: 'robotic process automation',
            title: 'Robotic Process Automation',
            link: '/services/robotic_process_automation',
        },
        {
            icon: iot,
            alt: 'iot',
            title: 'Internet Of Things (IoT)',
            link: '/services/iot_app',
        },
        {
            icon: ml,
            alt: 'machine learning',
            title: 'Machine Learning',
            link: '/services/machine_learning',
        },
        {
            icon: devops,
            alt: 'business intelligence',
            title: 'Business Intelligence',
            link: '/services/business_intelligence',
        },
        {
            icon: ai,
            alt: 'artificial intelligence',
            title: 'Artificial Intelligence',
            link: '/services/artificial_intelligence',
        },
    ];

    return (
        <Container>
            <Row>
                <Col xs={12}>
                    <h3 className="text-primary text-center mb-3 ft-wt-700">
                        How Can We Help You?
                    </h3>
                </Col>
            </Row>
            <Row className="row-cols-1 row-cols-md-2 row-cols-lg-4 row-cols-xl-5">
                {services.map((service, index) => (
                    <Col key={index} className="mb-3">
                        <Link to={service.link}>
                            <Card className="product-card">
                                <Card.Body className="text-center">
                                    <img className="mb-4" src={service.icon} alt={service.alt} />
                                    <p className="ft-wt-700">
                                        <Link to={service.link}>{service.title}</Link>
                                    </p>
                                    <h6 className="mb-0 mt-auto">
                                        <Link to={service.link}>Learn How</Link>
                                    </h6>
                                </Card.Body>
                            </Card>
                        </Link>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default ServicesCards;
